import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Footer. Phase 18-Z7 redesign + Phase 18-Z8 fix (2026-05-20):
 * nav links now use React Router <Link> instead of raw <a href>.
 * Raw <a href="/"> went to the absolute root (= admin app); <Link>
 * respects the BrowserRouter basename (/koreavsa/) so footer nav
 * stays inside the public site. data-cms-field attrs preserved.
 */
export default function Footer({ content }) {
    const footer = content?.footer || {}
    const contact = footer.contact || {}
    const siteName = content?.site?.name || ''

    return (
        <footer className="relative bg-ink-900 text-slate-300 overflow-hidden">
            {/* top gradient hairline */}
            <div className="h-1 w-full bg-gradient-to-r from-brand-600 via-cyan-500 to-brand-600" />
            <div className="container-fluid py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <div className="flex items-center gap-2.5 mb-4">
                        <span className="flex items-center justify-center h-9 w-9 rounded-lg bg-gradient-to-br from-brand-600 to-cyan-500 text-white font-extrabold text-lg">
                            K
                        </span>
                        <span data-cms-field="site.name" className="text-white text-base font-extrabold tracking-tight">
                            {siteName}
                        </span>
                    </div>
                    <div data-cms-field="site.tagline" className="text-sm text-slate-400 leading-relaxed">
                        {content?.site?.tagline || ''}
                    </div>
                </div>
                <div>
                    <div className="text-white text-xs font-bold mb-4 tracking-widest uppercase">Contact</div>
                    <div className="text-sm space-y-2">
                        {contact.address && (
                            <div data-cms-field="footer.contact.address" className="text-slate-400">{contact.address}</div>
                        )}
                        {contact.phone && (
                            <div data-cms-field="footer.contact.phone" className="text-slate-400">{contact.phone}</div>
                        )}
                        {contact.email && (
                            <div data-cms-field="footer.contact.email">
                                <a href={`mailto:${contact.email}`} className="text-brand-300 hover:text-cyan-300 transition">
                                    {contact.email}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <div className="text-white text-xs font-bold mb-4 tracking-widest uppercase">Links</div>
                    <ul data-cms-field="nav" className="text-sm space-y-2">
                        {(content?.nav || []).map((n, idx) => (
                            <li key={n.href || idx}>
                                <Link
                                    to={n.href || '/'}
                                    data-cms-field={`nav.${idx}.label`}
                                    className="text-slate-400 hover:text-white transition inline-flex items-center gap-1.5"
                                >
                                    <span className="w-1 h-1 rounded-full bg-brand-500" />
                                    {n.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div
                data-cms-field="footer.copyright"
                className="container-fluid py-6 border-t border-ink-600 text-xs text-slate-500"
            >
                {footer.copyright || ''}
            </div>
        </footer>
    )
}
